import { Icon as ChordsIcon } from '~/chords/Icon';

import { withClassNameHoc } from '../WithClassNameHoc';

export const Icon = withClassNameHoc(ChordsIcon);
Icon.displayName = 'Icon';
